import { render, staticRenderFns } from "./DetalhesProgramacao.vue?vue&type=template&id=4dd8f9b5"
import script from "./DetalhesProgramacao.vue?vue&type=script&lang=ts"
export * from "./DetalhesProgramacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports